import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Familiares } from '../../../../models/familiares';
import { MatDialog } from '@angular/material/dialog';
import { ErroresService } from '../../../../core/services/errores.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogConfirmacionComponent } from '../../../../components/shared/dialog-confirmacion/dialog-confirmacion.component';
import { DialogProcesandoComponent } from '../../../../components/shared/dialog-procesando/dialog-procesando.component';
import { IboxtoolsItem } from '../../../../models/iboxtools-item';
import { FamiliaresService } from '../../../../services/familiares.service';
import { FamiliarDetalleComponent } from '../familiar-detalle/familiar-detalle.component';
import { GruposLiquidacionService } from '../../../../services/gruposLiquidacion.service';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-familiares',
  templateUrl: './familiares.component.html',
  styleUrls: ['./familiares.component.css']
})
export class FamiliaresComponent implements OnInit, OnChanges {

  @Input() personalId;
  @Input() fechaslist;
  @Input() gruposLiquidaciones;
  disabledEditing: boolean;
  familiar: Familiares;
  verDetalle: boolean = false;
  isEditing: boolean = false;
  permisoEdicion: boolean = false;
  habilitarFormDetalle: boolean = false;
  MensajeError: string;

  //Control ibox
  familiaresHistoryList: any;
  familiaresList: Familiares[];
  toolboxEnabled: boolean = false;
  onlyNew: boolean = true;
  familiares: Familiares[];
  buscando: boolean;
  cortarRegistro: boolean = false;
  ingreso: any;
  
  desdeAnterior: boolean = false;
  anteriorRetroactividad: boolean = false;
  datosO:any;
  nacimientoposterior: boolean = false;
  familiaresInvalida: boolean = false;

  public cargaCompleta: boolean = false;

  @ViewChild('ChildFamiliarDetalle') familiarDetalle: FamiliarDetalleComponent;

  constructor(private familiaresService: FamiliaresService, 
              private dialog: MatDialog, 
              private erroresService: ErroresService, 
              private snackBar: MatSnackBar,
              private gruposLiquidacionService: GruposLiquidacionService,
              private momentService: MomentSetService) { }

  ngOnInit(): void
  {
    this.obtenerFamiliares(false);

    this.verPermiso();
  }

  async verPermiso() : Promise<void>  {
    let permisos = localStorage.getItem("Permisos");
    if (permisos.includes("Editar Familiares")) this.permisoEdicion = true;
  }

  obtenerFamiliares(agrupar)
  {
    this.buscando = true;
    this.familiaresService.getFamiliares(this.personalId, agrupar).subscribe(
      data =>
      {
        data.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
          currentValue.fechaNacimiento = this.momentService.convertDateServer(currentValue.fechaNacimiento);
          currentValue.presentacionCertificado = this.momentService.convertDateServer(currentValue.presentacionCertificado);
        });

        this.familiares = data;
        this.buscando = false;
        this.cargaCompleta = true;
      },
      error =>
      {
        this.cargaCompleta = true;
        this.buscando = false;
        console.log(error);
      });
  }

  ngOnChanges(changes: SimpleChanges): void
  {
    //throw new Error("Method not implemented.");
  }

  async OnVisualizarDetalle(familiar)
  {
    if (familiar.id != 0)
    {
      this.obtenerHistorial(familiar);
    }
    else
    {
      if (await this.verEstadoNomina())
      {
        this.verDetalle = true;
        this.familiar = familiar;
        this.habilitarEdicion();
      }
    }
  }

  async OnDeleteChange(event)
  {
    if (await this.validarEdicion(this.familiar))
    {
      this.MensajeError = "";
      let dialogRef = this.dialog.open(DialogConfirmacionComponent, {
        width: '400px',
      });

      dialogRef.componentInstance.mensaje = "¿Está seguro de eliminar?";

      dialogRef.afterClosed().subscribe(result =>
      {
        if (result != null && result)
        {
          let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
            width: '400px'
          });
          dialogProcesandoRef.componentInstance.Mensaje = "Eliminando...";

          this.familiaresService.eliminar(this.familiar.id).subscribe(
            response =>
            {
              this.snackBar.open("Familiar eliminado correctamente.", "OK", { duration: 10000 });
              setTimeout(function ()
              {
                dialogProcesandoRef.close();
              });

              let familiar = this.familiaresList.filter(d => d.id != this.familiar.id)[0];
              if (familiar == undefined)
              {
                this.volverAtras();
              }

              this.obtenerHistorial(familiar);
            },
            error =>
            {
              if (error.status == 400)
              {
              }
              else
              {
                this.erroresService.MostrarErrorByStatus(error, "Error al eliminar");
              }
              dialogProcesandoRef.close();
            });
        }
      });
    }
  }

  OnBackChange()
  {
    this.volverAtras();
  }

  async OnEditChange()
  {
    if (await this.validarEdicion(this.familiar))
    {
      this.habilitarEdicion();
      var $this = this;
      setTimeout(function ()
      {
        $this.familiarDetalle.form.controls['desde'].disable();
        $this.familiarDetalle.form.controls['hasta'].disable();
      });
    }
  }

  OnPeriodChange(index: number)
  {
    let familiar = this.familiaresList.find(d => d.id == index);
    this.familiar = familiar;
    this.MensajeError = "";
  }

  OnCancelChange(e: boolean)
  {
    this.familiarDetalle.setearForm(this.familiar);
    this.deshabilitarEdicion();
  }

  OnSaveChange(e: boolean)
  {
    if (this.validarDatos())
    {
      let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
        width: '400px'
      });
      dialogProcesandoRef.componentInstance.Mensaje = "Guardando...";

      let formulario = this.familiarDetalle.form.getRawValue();

      let datosFam: Familiares = {
        id: formulario.id,
        personal: formulario.personal,
        desde: this.momentService.saveDateServer(formulario.desde, false),
        hasta: this.momentService.saveDateServer(formulario.hasta, false),
        claseFamilia: formulario.claseFamilia,
        nacionalidad: formulario.nacionalidad,
        nombre: formulario.nombre,
        apellido: formulario.apellido,
        segundoApellido: formulario.segundoApellido,
        sexo: formulario.sexo,
        claseDocumento: formulario.claseDocumento,
        docNro: formulario.docNro,
        fechaNacimiento: this.momentService.saveDateServer(formulario.fechaNacimiento, false),
        pais: formulario.pais,
        estadoCivil: formulario.estadoCivil,
        celular: formulario.celular,
        email: formulario.email,
        discapacitado: formulario.discapacitado,
        contactoEmergencia: formulario.contactoEmergencia,
        presentacionCertificado: this.momentService.saveDateServer(formulario.presentacionCertificado, false),
        lugar: '',
        lugarNacimiento: ''
      };

      this.familiaresService.guardar(datosFam, this.cortarRegistro).subscribe(
        familiar =>
        {
          familiar.desde = this.momentService.convertDateServer(familiar.desde);
          familiar.hasta = this.momentService.convertDateServer(familiar.hasta);
          familiar.fechaNacimiento = this.momentService.convertDateServer(familiar.fechaNacimiento);
          familiar.presentacionCertificado = this.momentService.convertDateServer(familiar.presentacionCertificado);

          setTimeout(function ()
          {
            dialogProcesandoRef.close();
          });

          this.snackBar.open("Familiar guardado", "OK", { duration: 10000 });

          this.deshabilitarEdicion();

          this.obtenerHistorial(familiar);
          //TODO. Modificar la forma de obtener la fecha sin el TimeZone
          //familiar.desde = familiar.desde.replace('Z', '');
          this.familiarDetalle.setearForm(familiar);
        },
        error =>
        {
          dialogProcesandoRef.close();

          if (error.status == 400)
          {
            this.MensajeError = this.erroresService.MostrarError400(error);
          }
          else
          {
            this.erroresService.MostrarErrorByStatus(error, "Error al guardar");
          }
        });
    }
  }

  async OnNewChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.habilitarEdicion();
      this.familiarDetalle.form.controls['id'].setValue(0);
      this.familiarDetalle.form.controls['hasta'].setValue(new Date("2999-12-31T23:59:59"));
    }
  }

  async OnCutChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.cortarRegistro = true;
      this.habilitarEdicion();

      var $this = this;
      setTimeout(function ()
      {
        $this.familiarDetalle.form.controls['hasta'].disable();
      });
    }
  }

  private deshabilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = true;
    this.isEditing = false;
    this.habilitarFormDetalle = false;
    this.cortarRegistro = false;
  }

  private habilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = false;
    this.isEditing = true;
    this.habilitarFormDetalle = true;
  }

  private volverAtras()
  {
    this.desdeAnterior = false;
    this.anteriorRetroactividad = false;
    this.MensajeError = "";
    this.familiaresHistoryList = [];
    this.familiaresList = [];
    this.habilitarFormDetalle = false;
    this.verDetalle = false;
    this.obtenerFamiliares(false);
  }

  private obtenerHistorial(familiar: Familiares)
  {
    this.familiaresService.getHistoryByClase(familiar.personal, familiar.claseDocumento, familiar.docNro).subscribe(
      familiares =>
      {
        familiares.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
          currentValue.fechaNacimiento = this.momentService.convertDateServer(currentValue.fechaNacimiento);
          currentValue.presentacionCertificado = this.momentService.convertDateServer(currentValue.presentacionCertificado);
        });

        this.familiaresHistoryList = [];
        familiares.forEach(d =>
        {
          let item = new IboxtoolsItem(d);
          this.familiaresHistoryList.push(item);
        });

        this.familiaresList = familiares;
        this.verDetalle = true;
        this.familiar = familiar;
      },
      error =>
      {
        console.log(error);
      });
  }

  private validarDatos(): boolean
  {
    this.MensajeError = "";

    //TODO. Revisar
    if (this.familiarDetalle.form.get("sexo").value == 0)
    {
      this.familiarDetalle.form.get("sexo").setErrors({ 'invalid': true });
    }

    if (this.familiarDetalle.form.get("claseDocumento").value == 0)
    {
      this.familiarDetalle.form.get("claseDocumento").setErrors({ 'invalid': true });
    }

    if (this.familiarDetalle.form.get("pais").value == 0)
    {
      this.familiarDetalle.form.get("pais").setErrors({ 'invalid': true });
    }

    if (this.familiarDetalle.form.get("estadoCivil").value == 0)
    {
      this.familiarDetalle.form.get("estadoCivil").setErrors({ 'invalid': true });
    }

    if (this.familiarDetalle.form.get("claseFamilia").value == 0)
    {
      this.familiarDetalle.form.get("claseFamilia").setErrors({ 'invalid': true });
    }

    this.ingreso = this.fechaslist.find(d => d.claseFechaNavigation.codigo == "01");
    let desde = this.familiarDetalle.form.get("desde").value.toDateString();
    let hasta = this.familiarDetalle.form.get("hasta").value.toDateString();
    let hoy = new Date()

    let fingreso = new Date(this.ingreso.desde).toDateString();
    this.desdeAnterior = false;
    this.anteriorRetroactividad = false;
    this.nacimientoposterior = false;
    if (Date.parse(desde) < Date.parse(fingreso))
    {
      this.desdeAnterior = true;
      this.familiarDetalle.form.get("desde").setErrors({ 'anterior': true });
    } else {
      //valida que la fecha desde no sea anterior a la fecha de retroactividad del grupo de liquidacion vigente
      if (this.gruposLiquidaciones.periodoRetroactividad != null)
      {
        let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
        if (Date.parse(desde) < Date.parse(fretro) )
        {
          this.anteriorRetroactividad = true;
          this.familiarDetalle.form.get("desde").setErrors({'anteriorRetroactividad': true });
        }
      }
    }
    
    let nacimiento = this.familiarDetalle.form.get("fechaNacimiento").value.toDateString();
    if (Date.parse(desde) < Date.parse(nacimiento) )
    {
      this.nacimientoposterior = true;
      this.familiarDetalle.form.get("fechaNacimiento").setErrors({ 'invalid': true });
    }

    if (this.familiarDetalle.form.valid)
    {
      return true;
    }
    else
    {
      this.familiarDetalle.form.markAllAsTouched();
      return false;
    }
  }

  private async verEstadoNomina() : Promise<boolean>
  {
    let estadoValido = true;
    this.gruposLiquidaciones = await this.gruposLiquidacionService.GetVigenteByPersonal(this.personalId).toPromise();
    if (this.gruposLiquidaciones.estadoActual == 1) {
      estadoValido = false;
      this.snackBar.open("Acción no válida durante el Cálculo de la Nómina. Actualice el registro de gestión.", "OK", { duration: 10000 });
    }
    return estadoValido;
  }

  private validacionRetro(desde) : boolean
  {
    let anterior = false;
    
    if (this.gruposLiquidaciones.periodoRetroactividad != null)
    {
      let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
      if (Date.parse(desde) < Date.parse(fretro) )
      {
        anterior = true;
        this.snackBar.open("Acción no válida porque es anterior al límite de retroactividad.", "OK");
      }
    }
    return anterior;
  }

  private async validarEdicion(row) : Promise<boolean>
  {
    let edita = true;
    
    let estadoValido = await this.verEstadoNomina();
    if (estadoValido == false) edita = false;
    
    if(edita)
    {
      let anterior = this.validacionRetro(row.desde);
      if(anterior) edita = false;  
    }
    return edita;
  }
  
}
